import { Handle, MarkerType, Position } from "@xyflow/react";
import { enum_ENUM_FLUJO_EP } from "../../../../common/Dictionaries";

function insertWithRenumber(arr, nroRfas, position, newElements, revisionList) {
    arr.splice(position, 0, ...newElements);

    if (revisionList.length === 2) {
        if (nroRfas == 0) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Revisión 2
                                            (position + 1 === index) ?
                                            { x: 560, y: 10 } :
                                            (
                                                //Aprobación ADN
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //Aprobado
                                                    (position + 3 === index) ?
                                                    { x: 920, y: obj.position.y } :
                                                    obj.position
                                                )
                                            )
                                        )
                            )
            }));
        }
        if (nroRfas == 1) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Revisión 2
                                            (position + 1 === index) ?
                                            { x: 560, y: 10 } :
                                            (
                                                //Aprobación ADN
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //RFA 1
                                                    (position + 3 === index) ?
                                                    { x: 920, y: obj.position.y } :
                                                    (
                                                        //Aprobado
                                                        (position + 4 === index) ?
                                                        { x: 1080, y: obj.position.y } :
                                                        obj.position
                                                    )
                                                )
                                            )
                                        )
                            )
            }));
        }
        else if (nroRfas == 2) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Revisión 2
                                            (position + 1 === index) ?
                                            { x: 560, y: 10 } :
                                            (
                                                //Aprobación ADN
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //RFA 1
                                                    (position + 3 === index) ?
                                                    { x: 920, y: obj.position.y } :
                                                    (
                                                        //RFA 2
                                                        (position + 4 === index) ?
                                                        { x: 920, y: obj.position.y } :
                                                        (
                                                            //Aprobado
                                                            (position + 5 === index) ?
                                                            { x: 1080, y: obj.position.y } :
                                                            obj.position
                                                        )
                                                    )
                                                )
                                            )
                                        )
                            )
            }));
        }
        else if (nroRfas == 3) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Revisión 2
                                            (position + 1 === index) ?
                                            { x: 560, y: 10 } :
                                            (
                                                //Aprobación ADN
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //RFA 1
                                                    (position + 3 === index) ?
                                                    { x: 920, y: obj.position.y } :
                                                    (
                                                        //RFA 2
                                                        (position + 4 === index) ?
                                                        { x: 920, y: obj.position.y } :
                                                        (
                                                            //RFA 3
                                                            (position + 5 === index) ?
                                                            { x: 920, y: obj.position.y } :
                                                            (
                                                                //Aprobado
                                                                (position + 6 === index) ?
                                                                { x: 1050, y: obj.position.y } :
                                                                obj.position
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                            )
            }));
        }
    }
    if (revisionList.length === 1) {
        if (nroRfas == 1) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Aprobación ADN
                                            (position + 1 === index) ?
                                            { x: 560, y: obj.position.y } :
                                            (
                                                //RFA 1
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //Aprobado
                                                    (position + 3 === index) ?
                                                    { x: 920, y: obj.position.y } :
                                                    obj.position
                                                )
                                            )
                                        )
                            )
            }));
        }
        else if (nroRfas == 2) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Aprobación ADN
                                            (position + 1 === index) ?
                                            { x: 560, y: obj.position.y } :
                                            (
                                                //RFA 1
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //RFA 2
                                                    (position + 3 === index) ?
                                                    { x: 740, y: obj.position.y } :
                                                    (
                                                        //Aprobado
                                                        (position + 4 === index) ?
                                                        { x: 920, y: obj.position.y } :
                                                        obj.position
                                                    )
                                                )
                                            )
                                        )
                            )
            }));
        }
        else if (nroRfas == 3) {
            return arr.map((obj, index) => ({
                ...obj,
                id: String(index + 1),
                position:   (
                                //Revisión 1
                                (position === index) ?
                                        { x: 380, y: 10 } :
                                        (
                                            //Aprobación ADN
                                            (position + 1 === index) ?
                                            { x: 560, y: obj.position.y } :
                                            (
                                                //RFA 1
                                                (position + 2 === index) ?
                                                { x: 740, y: obj.position.y } :
                                                (
                                                    //RFA 2
                                                    (position + 3 === index) ?
                                                    { x: 740, y: obj.position.y } :
                                                    (
                                                        //RFA 3
                                                        (position + 4 === index) ?
                                                        { x: 740, y: obj.position.y } :
                                                        (
                                                            //Aprobado
                                                            (position + 5 === index) ?
                                                            { x: 920, y: obj.position.y } :
                                                            obj.position
                                                        )
                                                    )
                                                )
                                            )
                                        )
                            )
            }));
        }
    }
}

export function manageDynamicNodes(initialNodes, nroRfasWithAdn, revisionList, positionDynamicNode, estadoFlujoId) {
    const insertPosition = positionDynamicNode -1;//Para que cuadre con indice 0.
    const nroRfas = nroRfasWithAdn -1;
    let dynamicElement = [];

    revisionList.forEach(element => {
        dynamicElement.push({ id: `0`, data: { label: `${element.nombre}` }, sourcePosition: 'right', targetPosition: 'left', position: { x: 0, y: 0 },  style: { cursor: 'pointer', height: 300,  width: 130,  border: '1px solid #000', borderRadius: '5px', color: (estadoFlujoId === enum_ENUM_FLUJO_EP.REVISION ? (element.highlight === true ? 'white' : '') : ''), backgroundColor: (estadoFlujoId === enum_ENUM_FLUJO_EP.REVISION ? (element.highlight === true ? '#31a915' : '') : '') } })
    });

    if (revisionList.length > 0) {
        return insertWithRenumber(initialNodes, nroRfas, insertPosition, dynamicElement, revisionList);
    }
    else {
        return initialNodes;
    }
}

export function manageDynamicEdges(initialEdges, revisionList, positionDynamicNode) {
    const approvedNodePosition = 7;
    for (let index = 0; index < revisionList.length; index++) {
        initialEdges.push({ id: `e${initialEdges.length - 1}-${initialEdges.length}`, source: `${initialEdges.length - 1}`, target: (`${approvedNodePosition + (index + 1)}`), animated: false, label: '', type: 'step', style: {stroke: '#b1b1b7', strokeWidth: 2} , markerEnd: { type: MarkerType.ArrowClosed, color: '#b1b1b7', width: 25, height: 25 } });
    }

    return initialEdges
}

export function manageDynamicEdges2(initialEdges, revisionList, positionDynamicNode) {
    const approvedNodePosition = 7;
    for (let index = 0; index < revisionList.length; index++) {
        initialEdges.push({ id: `e${initialEdges.length - 1}-${initialEdges.length}`, source: `${initialEdges.length - 1}`, target: (`${approvedNodePosition + (index)}`), animated: false, label: '', type: 'step', style: {stroke: '#b1b1b7', strokeWidth: 2} , markerEnd: { type: MarkerType.ArrowClosed, color: '#b1b1b7', width: 25, height: 25 } });
    }

    return initialEdges
}

export const CustomNode = ({ data }) => {
    return (
        <div className='text-center' style={{ padding: 10, borderRadius: 5, fontSize: 12 }}>
            <Handle type="source" position={Position.Right}  id="rightHandle"  style={{ background: '#555' }} />
            <Handle type="source" position={Position.Bottom} id="bottomHandle" style={{ background: '#555' }} />
            <Handle type="target" position={Position.Left}   id="leftHandle"   style={{ background: '#555' }} />
            <b style={{fontSize: "16px"}}>{data.label}</b>
        </div>
    );
};